module.exports = __webpack_public_path__ + "img/fuzzy@2x copy.712e2303.png";